var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretUpdown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.622 3.43a.5.5 0 01.752 0l2.399 2.74a.5.5 0 01-.377.83H5.6a.5.5 0 01-.376-.83l2.398-2.74zM8.374 12.57a.5.5 0 01-.752 0L5.224 9.83A.5.5 0 015.6 9h4.796a.5.5 0 01.377.83l-2.399 2.74z",
    fill: "#CED4DA"
  })));
}

export default SvgCaretUpdown16;